import { APP_INITIALIZER, NgModule } from '@angular/core';
import { provideDatadogErrorHandler, provideDatadogRouter } from '@datadog/browser-rum-angular';
import { AppComponent } from './app.component';
import { AppModule } from './app.module';
import { DatadogRumService } from './shared/services/datadog-rum.service';

/**
 * Wraps the shared `AppModule` with browser-only providers.
 *
 * `AppModule` is imported by both this module (bootstrapped client-side from
 * main.ts) and `AppServerModule` (bootstrapped server-side for SSR). Kept
 * out of `AppModule` itself because `provideDatadogRouter()` /
 * `provideDatadogErrorHandler()` install Datadog's router hooks and
 * ErrorHandler — installing those in the Node.js SSR renderer for a
 * client-only SDK that never actually initializes there would be wrong, so
 * this browser-only wrapper is the bootstrap target instead. Mirrors the
 * split used in the VSH/VAX spartacusstore (USONESHOP-3875), adapted from
 * its standalone `bootstrapApplication` config to this app's NgModule
 * bootstrap.
 */
@NgModule({
  imports: [AppModule],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (datadog: DatadogRumService) => () => datadog.init(),
      deps: [DatadogRumService],
      multi: true,
    },
    provideDatadogRouter(),
    provideDatadogErrorHandler(),
  ],
})
export class AppBrowserModule {}
